import { theme, type ThemeConfig } from 'antd';
import { BRAND } from '@/constants/brand';
import type { ResolvedTheme } from '@/types/ui';

export function getAntdTheme(resolvedTheme: ResolvedTheme): ThemeConfig {
  const isDark = resolvedTheme === 'dark';

  return {
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: BRAND.primary,
      colorInfo: BRAND.primary,
      colorLink: BRAND.primary,
      colorLinkHover: BRAND.primaryDark,
      colorError: BRAND.redButton,
      colorWarning: BRAND.orange,
      colorSuccess: BRAND.green,
      colorText: isDark ? BRAND.cream : BRAND.heading,
      colorTextSecondary: isDark ? '#C9BFB4' : BRAND.paragraph,
      colorTextTertiary: BRAND.paragraphGray,
      colorTextPlaceholder: BRAND.placeholder,
      borderRadius: 10,
      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      ...(isDark
        ? {
            colorBgBase: BRAND.darkBg,
            colorBgContainer: BRAND.darkSurface,
            colorBgElevated: '#5A4A3D',
          }
        : {
            colorBgLayout: BRAND.cream,
            colorBgBase: BRAND.warmWhite,
            colorBgContainer: '#FFFFFF',
            colorPrimaryBg: 'rgba(155, 126, 84, 0.08)',
            colorPrimaryBorder: BRAND.inputBorder,
            colorPrimaryHover: BRAND.primaryDark,
          }),
    },
    components: {
      Button: {
        controlHeight: 36,
        primaryShadow: BRAND.shadow,
        colorPrimary: BRAND.primary,
        colorPrimaryHover: BRAND.primaryDark,
      },
      Input: {
        activeBorderColor: BRAND.primary,
        hoverBorderColor: BRAND.primaryLight,
        activeShadow: '0 0 0 2px rgba(155, 126, 84, 0.15)',
      },
      Form: { labelColor: BRAND.label },
      Menu: {
        darkItemSelectedBg: 'rgba(155, 126, 84, 0.28)',
        darkItemHoverBg: 'rgba(155, 126, 84, 0.16)',
      },
      Table: {
        borderRadius: 10,
        rowHoverBg: '#F5F0EA',
      },
      Card: {
        borderRadiusLG: 12,
      },
    },
  };
}
